import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private toggleDropdownSource = new Subject<void>();
  private getNotificationsSource = new Subject<void>(); // New BehaviorSubject
  private isFetchingNotifications: boolean = false;
  private lastFetchTime: number = 0;
  private readonly FETCH_DEBOUNCE_MS = 1000; // Prevent duplicate calls within 1 second across all instances

  toggleDropdown$ = this.toggleDropdownSource.asObservable();
  getNotifications$ = this.getNotificationsSource.asObservable(); // Observable for notifications


  toggleDropdown(): void {
    console.log('Toggling notification dropdown'); // Log to verify
    this.toggleDropdownSource.next();
  }

    // Method to trigger getNotifications
    triggerGetNotifications(): void {
      this.getNotificationsSource.next(); // Triggers the notification fetching process
    }

    // Check if notifications can be fetched (prevents duplicate calls across component instances)
    canFetchNotifications(): boolean {
      const now = Date.now();
      if (this.isFetchingNotifications || (now - this.lastFetchTime < this.FETCH_DEBOUNCE_MS)) {
        return false;
      }
      this.isFetchingNotifications = true;
      this.lastFetchTime = now;
      return true;
    }

    // Mark notification fetch as complete
    markNotificationFetchComplete(): void {
      this.isFetchingNotifications = false;
    }
    
}
